module.exports = __webpack_public_path__ + "img/iot4shm-login.9e23156c.png";